import { Card, CardBody, Col } from "reactstrap";
import CommonCardFooter from "../../../Common/CommonCardFooter";
import WithoutBordersStyleForm from "./WithoutBordersStyleForm";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { WithoutBordersStyleTitle } from "../../../../../../Constants/Constants";
import { WithoutBordersStyleSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormControls";

const WithoutBordersStyle = () => {
  return (
    <Col sm="12" xxl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={WithoutBordersStyleTitle} span={WithoutBordersStyleSubTitle} />
        <CardBody>
          <WithoutBordersStyleForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="warning" color2="transparent" btn2Class="list-light-warning" />
      </Card>
    </Col>
  );
};
export default WithoutBordersStyle;
